<template>
  <ConsentConfig />
</template>

<script setup lang="ts">
import ConsentConfig from './ConsentConfig.vue';
</script>
